// extracted by mini-css-extract-plugin
export default {"field":"app-lists-EventResponsibilitiesField-EventResponsibilitiesField-module__DGFzDK6_IeBIPP8S0YdR"};